export var system = {
  name: "系统管理",
  path: "/system",
  hidden: false,
  redirect: "noredirect",
  component: "Layout",
  elemCode: "3",
  sort: 10,
  alwaysShow: true,
  meta: {
    title: "系统管理",
    icon: "system1",
    noCache: false
  },
  children: [{
    name: "orgManagement",
    path: "/orgManagement",
    hidden: false,
    component: "system/orgManagement/index",
    elemCode: "15",
    meta: {
      title: "机构管理",
      noCache: true
    }
  }, {
    name: "ChooseVehicle",
    path: "/orgManagement/carList",
    hidden: true,
    component: "system/orgManagement/ChooseVehicle",
    elemCode: "17",
    meta: {
      title: "机构车辆",
      noCache: true
    }
  }, {
    name: "UserManage",
    path: "/userManage",
    hidden: false,
    component: "system/user/index",
    elemCode: "4",
    meta: {
      title: "用户管理",
      noCache: true
    }
  }, {
    name: "Role",
    path: "role",
    hidden: false,
    component: "system/role/index",
    elemCode: "5",
    meta: {
      title: "角色管理",
      noCache: false
    }
  }, {
    name: "Dept",
    path: "dept",
    hidden: false,
    component: "system/dept/index",
    elemCode: "93",
    meta: {
      title: "部门管理",
      noCache: true
    }
  }, {
    name: "Dict",
    path: "dict",
    hidden: false,
    component: "system/dict/index",
    elemCode: "94",
    meta: {
      title: "字典管理",
      noCache: true
    }
  }, {
    name: "FileOperationManage",
    path: "FileOperationManage",
    hidden: false,
    component: "system/ykApplicationManage/FileOperationManage/index",
    elemCode: "107",
    meta: {
      title: "文件操作管理",
      noCache: true
    }
  }, {
    name: "Log",
    path: "logs",
    hidden: false,
    component: "monitor/log/index",
    elemCode: "95",
    meta: {
      title: "操作日志",
      noCache: true
    }
  }, {
    name: "ErrorLog",
    path: "errorLog",
    hidden: false,
    component: "monitor/log/errorLog",
    elemCode: "96",
    meta: {
      title: "异常日志",
      noCache: true
    }
  }, {
    name: "YKMenusManage",
    path: "YKMenusManage",
    hidden: false,
    component: "ykMenusManage/index",
    elemCode: "159",
    meta: {
      title: "菜单管理",
      noCache: true
    }
  }]
};